module.exports = __webpack_public_path__ + "static/media/carta.766cd120.svg";